import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import ResultsPage1 from "./ResultsPage1";

const Results = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if this is an emergency case (has a result with amIOKScore of 100)
    const result = location.state?.result;
    const isEmergency = result && result.amIOKScore === 100;
    
    // Only redirect to assessment page if this is NOT an emergency case
    if (!isEmergency) {
      navigate('/results/assessment', { 
        state: location.state,
        replace: true 
      });
    }
  }, [navigate, location.state]);

  // For emergency cases, render ResultsPage1 directly without redirect
  return <ResultsPage1 />;
};

export default Results;